import {
  arrayOf, bool, number, oneOfType, shape, string,
} from 'prop-types';

const IMAGE = {
  source: string,
  uri: string,
};

const PAGE = {
  id: string,
  background: shape({
    color: string,
    image: string,
    opacity: number,
    video: string,
  }),
  image: oneOfType([string, shape(IMAGE)]),
  images: arrayOf(string),
  location: shape({
    author: string,
    country: string,
    text: string,
  }),
  rights: string,
  subtitle: string,
  summary: string,
  text: string,
  title: string,
  type: string,
};

const RELATED = {
  id: string,
  title: string,
  caption: string,
  backgroundColor: string,
  image: string,
  sponsored: bool,
};

export default {
  IMAGE,

  LINK: {
    title: string,
    uri: string,
    color: string,
  },

  LOCATION: {
    author: string,
    avatar: string,
    country: string,
    title: string,
  },

  PAGE,

  SESSION: {
    device_id: string,
    user_id: string,
  },

  STORY: {
    id: string,
    title: string,
    description: string,
    logo: string,
    url: string,
    related: arrayOf(shape(RELATED)),
    pages: arrayOf(shape(PAGE)),
  },
};
